import { render, staticRenderFns } from "./nature-of-feedback.vue?vue&type=template&id=50f6d991&"
import script from "./nature-of-feedback.vue?vue&type=script&lang=js&"
export * from "./nature-of-feedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports